import { Component, OnInit, ViewChild } from '@angular/core';
import { WayfindingComponent } from '../wayfinding/wayfinding.component';
import { GoogleAnalyticsService } from '../google-analytics.service';
import { TotemService } from '../totem.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-estacionamientos',
  templateUrl: './estacionamientos.component.html',
  styleUrls: ['./estacionamientos.component.css']
})
export class EstacionamientosComponent implements OnInit {
  estacactual;
  idest = 0;
  zoomactivo = true;
  estid;
  rutaalt = false;
  planos: Array<any>;
  opcionmapa = 'totem';
  rutaenviar = environment.tipoTransporte.pie;
  estacionamientosid = environment.idEst;
  colorest = environment.colorEst;
  datoest = [];
  constructor(private googleAnalyticsService: GoogleAnalyticsService, private totemService: TotemService) {}

  async ngOnInit() {
    await this.totemService.getTotemConfig();
     // logica pra los planos
    this.planos = await this.totemService.getPlanos().toPromise();
    for (const plano of this.planos) {
      const numero = plano.piso_numero;
      if (numero > 0 ) {
      plano.nombre = 'N' + String(numero);
      } else {
        const piso = numero.toString()[1];
        plano.nombre = 'S' + piso;
      } if (numero == 0) {
        const piso = numero.toString()[1];
        plano.nombre = 'N0' ;
      }
    }
    // logica estacionamientos nueva
    for (let i = 0; i < this.estacionamientosid.length; i++) {
      this.datoest.push(
        {
          id: this.estacionamientosid[i],
          color: this.colorest[i]
        });
    }
    this.estid = this.datoest[0];
    this.enviarEventoFiltro(this.estacactual);
  }
  selctedlevel(est: any) {
    this.cancelartimer();
    this.opcionmapa = 'estacionamiento';
    const color = est.color;
    this.estid = est.id;
    this.idest = est.id;

    this.estacactual = color;
    this.enviarEventoFiltro(color);
  }
  hacerzoom() {
    this.zoomactivo = !this.zoomactivo;
  }
  public enviarEventoFiltro(color) {
    this.googleAnalyticsService.eventEmitter(
      'estacionamientos',
      'filter',
      color
    );
  }
  public iconoruta() {
    this.rutaenviar = this.rutaenviar === environment.tipoTransporte.pie ?
    environment.tipoTransporte.alternativo :
    environment.tipoTransporte.pie;
    
    this.rutaalt = !this.rutaalt;
  }
  // logica de reinicio
  scrollevent = (event: any): void => {
    console.log('scroll');
    this.cancelartimer();
 }
 public cancelartimer() {
   this.totemService.emitirReinicioTotem();
 }
}
